var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "promotion-item" },
    [
      _c(
        "div",
        { staticClass: "main" },
        [
          _c("div", [
            _c("div", { staticClass: "promotion-item-publication" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("fullDate")(_vm.info.issuedOn)) +
                  "\n      "
              )
            ]),
            _c("div", { staticClass: "promotion-item-title" }, [
              _vm._v("\n        " + _vm._s(_vm.info.name) + "\n      ")
            ]),
            _c(
              "div",
              { staticClass: "promotion-item-date" },
              [
                _vm.isCoupon
                  ? _c("span", [
                      _vm._v(
                        "\n          Срок действия промокода: " +
                          _vm._s(_vm._f("fullDate")(_vm.info.dateBegin)) +
                          " - " +
                          _vm._s(_vm._f("fullDate")(_vm.info.dateEnd)) +
                          ".\n        "
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n          от " +
                          _vm._s(_vm._f("fullDate")(_vm.info.dateBegin)) +
                          "\n        "
                      )
                    ]),
                _vm.info.description
                  ? [
                      _c(
                        "vue-client-only",
                        [
                          _vm.adaptive.isMobile
                            ? _c("hint-block", {
                                attrs: {
                                  title: "Подробнее",
                                  description: _vm.info.description
                                }
                              })
                            : _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.descriptionOpened = !_vm.descriptionOpened
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Подробнее\n              "
                                  ),
                                  _c("chevron-animated", {
                                    attrs: { reverse: _vm.descriptionOpened }
                                  })
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          ]),
          _vm.isCoupon
            ? _c("ui-button", {
                staticClass: "promo-button",
                attrs: {
                  wide: "",
                  text: _vm.info.id,
                  icon: _vm.$options.icons.IconCopy.id
                },
                on: { click: _vm.copyCode }
              })
            : _vm._e()
        ],
        1
      ),
      _c("vue-client-only", [
        !_vm.adaptive.isMobile
          ? _c(
              "div",
              {
                class: [
                  "promotion-item-description",
                  { opened: _vm.descriptionOpened }
                ]
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.info.description || "") + "\n    "
                )
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }